import { QuestionHistorical } from '../../../../shared/types/survey.interface';

export interface QuestionHistoricalModalProps {
    historical: QuestionHistorical[];
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    status: 'Estado',
    required: 'Requerido',
    why: '¿Por qué?',
    answerTextDependency: 'Rango',
    dependency: 'Dependencia',
    description: 'Descripción',
    range: 'Rango',
    icon: 'Icono',
    label: 'Etiqueta',
    questionDependency: 'Pregunta a depender',
    answerName: 'Respuesta a depender',
    answerDependency: 'Respuesta a depender',
};
